module.exports = __webpack_public_path__ + "static/img/groundabout3.e68ad9e7.png";